import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PageActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Page/PageBrowser")
	}

	render() {
		return (
			<Activity 
				name="Page"
				RenderedComponent={this.RenderedComponent}
                context="page"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PageActivity)
